module.exports = __webpack_public_path__ + "static/media/fanyuvo_logo_big_en.65dd29cc.png";